<!--网站首页-->
<template>
  <div>
    <el-row>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>

      <!--走马灯-->
      <el-col :span='8'>
        <div class='grid_content'>
          <div class='block'>
            <el-carousel height='360px'>
              <el-carousel-item v-for='item in carouselList' :key='item.id'>
                <div class='pic_item' @click='jump(item)'>
                  <el-image class='small'
                            v-if='item.homeImage != null'
                            :src='item.imageUrl'
                  />
                  <h3>{{ item.title }}</h3>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-col>

      <!--新闻、通知-->
      <el-col :span='8'>
        <div class='grid_content'>
          <el-tabs type='border-card'>
            <el-tab-pane label='新闻'>
              <ul>
                <li v-for='item in newsList' :key='item.id'>
                  <a @click='jump(item)'>{{ item.title }}</a>
                  <span>{{ item.creteNewTime }}</span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label='会议通知'>
              <ul>
                <li v-for='item in meetingList' :key='item.id'>
                  <a @click='jump(item)'>{{ item.title }}</a>
                  <span>{{ item.creteNewTime }}</span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label='活动通知'>
              <ul>
                <li v-for='item in activityList' :key='item.id'>
                  <a @click='jump(item)'>{{ item.title }}</a>
                  <span>{{ item.creteNewTime }}</span>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>

    <!-- 第二排内容-->
    <el-row>
      <el-col :span='4'>
        <div class='grid-content1'></div>
      </el-col>
      <el-col :span='5'>
        <div class='grid-content1' style='background-color: #fff;'>
          <div class='bg'>
            <p>环保动态</p>
            <span @click='typeList(1)'><a>MORE</a></span>
          </div>
          <div>
            <ul>
              <li style='height: 120px;border: 0'>
                <div class='pic_item_1' @click='jump(environmental)'>
                  <el-image class='small' :src='environmental.imageUrl' />
                  <h3>{{ environmental.title }}</h3>
                </div>

              </li>
              <li>
                <ul v-for='item in environmentalList' :key='item.id' @click='jump(item)'>
                  <li class='icon'>
                    <i class='el-icon-document'></i>
                  </li>
                  <li class='title'>
                    <a>{{ item.title }} </a>
                  </li>
                  <li class='date'>
                    <span>{{ item.creteNewTime }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span='6'>
        <div class='grid-content1' style='width: 83.33%;margin: 0 auto;background-color: #fff;'>
          <div class='bg'>
            <p>研究资讯</p>
            <span @click='typeList(2)'><a>MORE</a></span>
          </div>
          <div>
            <ul>
              <li style='height: 120px;border: 0'>
                <div class='pic_item_1' @click='jump(information)'>
                  <el-image class='small' :src='information.imageUrl' />
                  <h3>{{ information.title }}</h3>
                </div>
              </li>
              <li>
                <ul v-for='item in informationList' :key='item.id' @click='jump(item)'>
                  <li class='icon'>
                    <i class='el-icon-document'></i>
                  </li>
                  <li class='title'>
                    <a>{{ item.title }} </a>
                  </li>
                  <li class='date'>
                    <span>{{ item.creteNewTime }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </el-col>

      <el-col :span='5'>
        <div class='grid-content1' style='background-color: #fff;'>
          <div class='bg'>
            <p>头条推荐</p>
            <span @click='typeList(3)'><a>MORE</a></span>
          </div>
          <div>
            <ul>
              <li style='height: 120px;border: 0'>
                <div class='pic_item_1' @click='jump(headlines)'>
                  <el-image class='small' :src='headlines.imageUrl' />
                  <h3>{{ headlines.title }}</h3>
                </div>
              </li>
              <li>
                <ul v-for='item in headlinesList' :key='item.id' @click='jump(item)'>
                  <li class='icon'>
                    <i class='el-icon-document'></i>
                  </li>
                  <li class='title'>
                    <a>{{ item.title }} </a>
                  </li>
                  <li class='date'>
                    <span>{{ item.creteNewTime }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid-content1'></div>
      </el-col>
    </el-row>

    <!-- 第三排内容-->
    <el-row>
      <el-col :span='4'>
        <div class='grid-content1'></div>
      </el-col>
      <el-col :span='5'>
        <div class='grid-content1' style='background-color: #fff;'>
          <div class='bg'>
            <p>低碳生活</p>
            <span @click='typeList(4)'><a>MORE</a></span>
          </div>
          <div>
            <ul>
              <li style='height: 120px;border: 0'>
                <div class='pic_item_1' @click='jump(lowCarbon)'>
                  <el-image class='small' :src='lowCarbon.imageUrl' />
                  <h3>{{ lowCarbon.title }}</h3>
                </div>

              </li>
              <li>
                <ul v-for='item in lowCarbonList' :key='item.id' @click='jump(item)'>
                  <li class='icon'>
                    <i class='el-icon-document'></i>
                  </li>
                  <li class='title'>
                    <a>{{ item.title }} </a>
                  </li>
                  <li class='date'>
                    <span>{{ item.creteNewTime }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </el-col>

      <el-col :span='6'>
        <div class='grid-content1' style='width: 83.33%;margin: 0 auto;background-color: #fff;'>
          <div class='bg'>
            <p>平台伙伴</p>
            <span @click='typeList(5)'><a>MORE</a></span>
          </div>
          <div>

            <ul>
              <li v-for='item in partnerList' :key='item.id' class='platformPartners'>
                <a @click='typeList(5)'>{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </el-col>

      <el-col :span='5'>
        <div class='grid-content1' style='background-color: #fff;'>
          <div class='bg'>
            <p>专家达人</p>
            <span @click='typeList(6)'><a>MORE</a></span>
          </div>
          <div>
            <ul class='aMaster' v-for='item in expertList' :key='item.id' @click='jump(item)'>
              <li>
                <div class='pic_item_1'>
                  <el-image class='smallNew' :src='item.imageUrl' />
                  <h3>{{ item.title }}</h3>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid-content1'></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {
  homeNewsList, homeCarousel, homeEnvironmental, homeInformation, homeHeadlines,
  homeLowCarbon, homePartner, homeExpert
} from '@/api/auth'
import { h } from 'vue'

export default {
  created () {
    this.getList()
    this.getHomeCarousel()
    this.getHomeEnvironmental()
    this.getHomeInformation()
    this.getHomeHeadlines()
    this.getHomeLowCarbon()
    this.getHomePartner()
    this.getHomeExpert()
  },
  inject: ['say'],

  methods: {
    h,
    animates () {
      console.log('被父页面点击了')
    },

    getList () {
      let that = this
      homeNewsList(this.queryParams).then(res => {
        that.newsList = res.data.newsList
        that.meetingList = res.data.meetingList
        that.activityList = res.data.activityList
      })
    },
    /** 首页轮播 */
    getHomeCarousel () {
      let that = this
      homeCarousel(this.queryParams).then(res => {
        res.data.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        that.carouselList = res.data
      })
    },
    /** 环保动态 */
    getHomeEnvironmental () {
      let that = this
      homeEnvironmental(this.queryParams).then(res => {
        res.data.forEach((value, index) => {
          if (index === 0) {
            that.environmental.id = value.id
            that.environmental.title = value.title
            if (value.homeImage != null) {
              that.environmental.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
            } else {
              that.environmental.imageUrl = that.src
            }
          }
        })
        that.environmentalList = res.data
        that.environmentalList.splice(0, 1)
      })
    },
    /** 研究资讯 */
    getHomeInformation () {
      let that = this
      homeInformation(this.queryParams).then(res => {
        res.data.forEach((value, index) => {
          if (index === 0) {
            that.information.id = value.id
            that.information.title = value.title
            if (value.homeImage != null) {
              that.information.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
            } else {
              that.information.imageUrl = that.src
            }
          }
        })
        that.informationList = res.data
        that.informationList.splice(0, 1)
      })
    },
    /** 头条推荐 */
    getHomeHeadlines () {
      let that = this
      homeHeadlines(this.queryParams).then(res => {
        res.data.forEach((value, index) => {
          if (index === 0) {
            that.headlines.id = value.id
            that.headlines.title = value.title
            if (value.homeImage != null) {
              that.headlines.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
            } else {
              that.headlines.imageUrl = that.src
            }
          }
        })
        that.headlinesList = res.data
        that.headlinesList.splice(0, 1)
      })
    },
    /** 专家达人 */
    getHomeExpert () {
      let that = this
      homeExpert(this.queryParams).then(res => {
        res.data.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        that.expertList = res.data
      })
    },

    /** 低碳生活 */
    getHomeLowCarbon () {
      let that = this
      homeLowCarbon(this.queryParams).then(res => {
        res.data.forEach((value, index) => {
          if (index === 0) {
            that.lowCarbon.id = value.id
            that.lowCarbon.title = value.title
            if (value.homeImage != null) {
              that.lowCarbon.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
            } else {
              that.lowCarbon.imageUrl = that.src
            }
          }
        })
        that.lowCarbonList = res.data
        that.lowCarbonList.splice(0, 1)
      })
    },
    /** 低碳生活 */
    getHomePartner () {
      let that = this
      homePartner(this.queryParams).then(res => {
        that.partnerList = res.data
      })
    },
    jump (raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id
        }
      })
    },
    typeList (raw) {
      this.say(raw)
    }
  },
  data () {
    return {
      newsList: [],
      expertList: [],
      carouselList: [],
      partnerList: [],
      environmentalList: [],
      environmental: {
        id: '',
        imageUrl: '',
        title: ''
      },
      headlinesList: [],
      headlines: {
        id: '',
        imageUrl: '',
        title: ''
      },
      lowCarbonList: [],
      lowCarbon: {
        id: '',
        imageUrl: '',
        title: ''
      },
      informationList: [],
      information: {
        id: '',
        imageUrl: '',
        title: ''
      },
      meetingList: [],
      activityList: [],

      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',

      queryParams: {}
    }
  }
}
</script>

<style lang='less' scoped>
.el-row {
  padding-bottom: 25px;
  background-color: #eee;

  &:last-child {
    margin-bottom: 0;
  }
}

//新闻、通知样式
.grid_content {
  min-height: 36px;
  height: 360px;

  ul {
    list-style-type: disc;
    color: #666;

    li {
      margin-left: 12px;
      height: 48px;
      line-height: 48px;
      border-bottom: 1px dashed #999;
      padding-right: 20px;

      a {
        width: 85%;
        display: block;
        float: left;
        color: #666;
        font-size: 15px;
        font-family: "黑体";
        overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap; /*文本不换行*/
      }

      a:hover {
        color: #409EFF;
      }

      span {
        float: right;
        width: 15%;
      }
    }
  }
}

::v-deep .el-tabs__nav-scroll {
  margin: 0 auto;
  background-color: #fff;

  .el-tabs__item {
    font-size: 16PX !important;
    font-weight: bold;
    font-family: “黑体”;
    color: #666 !important;
    width: 34%;
    text-align: center;
    background-color: #fff;
    margin-bottom: -1px;
  }
}

::v-deep .el-tabs__item:hover {
  color: #409EFF
}

::v-deep .el-tabs__item:focus {
  color: #409EFF;
  border-left: 0px;
  border-right: 0px;
}

// 默认选中的样式
::v-deep .el-tabs__item.is-active {
  color: #409EFF !important;
}

//第二排 环保动态、研究资讯、头条推荐样式
.grid-content1 {
  height: 420px;

  .bg {
    width: 100%;
    height: 42px;
    background-color: #6aa84f;
    position: relative;

    P {
      background-color: #fff;
      font-size: 16px;
      font-family: " 黑体";
      font-weight: bold;
      width: 28%;
      text-align: center;
      line-height: 30px;
      height: 30px;
      margin-left: 12px;
      position: absolute;
      bottom: 0px;
      border-radius: 10px 10px 0px 0px;
    }

    span {
      float: right;
      line-height: 42px;
      margin-right: 12px;

      a {
        color: #fff;
      }

      a:hover {
        text-decoration: underline;
      }
    }
  }

  li {
    width: 90%;
    margin: 0 auto;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px dashed #999;

    .img {
      height: 120px;
      display: block;
      margin: 15px auto 0;
    }

    .icon {
      width: 5%;
      float: left;
      height: 45px;
      line-height: 45px;
    }

    .title {
      font-family: "黑体";
      float: left;
      width: 70%;
      overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
      text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
      white-space: nowrap; /*文本不换行*/

      a {
        color: #333;
      }

      a:hover {
        color: #1890ff;
      }
    }

    .date {
      width: 25%;
      float: right;
      color: #999;
    }
  }

  //平台伙伴
  .platformPartners {
    border: 1px solid #333;
    margin-top: 6px;

    a {
      height: 43px;
      display: block;
      font-size: 14px;
      color: #333;
      text-align: center;
    }

    a:hover {
      background-color: #409EFF;
      color: #fff;
    }
  }

  //专家达人
  .aMaster {
    margin: 10px 0 10px 10px;

    li {
      width: 30.7%;
      height: 168px;
      margin: 0 10px 10px 0;
      border: 1px solid white;
      display: block;
      float: left;
    }

    .img {
      width: 100%;
      height: 100%;
    }
  }
}

.small {
  width: 100%;
  height: 100%;
  position: relative;
}

.smallNew {
  width: 100%;
  height: 100%;
  position: relative;

}

.smallNew:hover {
  width: 100%;
  height: 100%;
  transform: scale(1.1); //图片按照比例，整体放大了1.2倍
  // 当鼠标经过是图片放大的倍数为1.2倍
}

.pic_item {
  position: relative;
  height: 100%;
}

.pic_item:hover {
  cursor: pointer;
}

.pic_item img {
  width: 100%;
  height: 100%;
}

.pic_item h3 {
  position: absolute;
  color: #ffffff;
  left: 1rem;
  bottom: 2rem;
}

.pic_item_1 {
  position: relative;
  height: 100%;
}

.pic_item_1:hover {
  cursor: pointer;
}

.pic_item_1 img {
  width: 100%;
  height: 100%;
}

.pic_item_1 h3 {
  position: absolute;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  height: 25px;
  line-height: 25px;
  width: 100%;
  background-color: rgba(14, 13, 13, .5);
  bottom: 0px;
}

//走马灯
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
